export default "__VITE_PUBLIC_ASSET__18657ad6__"